import { logEventString } from '@adv-frontend/yastore-modules/logger';
import { type BannerCommunication } from '../../model/selectBannerCommunication';
import { communicationBannerTestIds } from '../../testids';
import { CommunicationBannerView } from '../CommunicationBannerView';

type Props = {
    communication: BannerCommunication;
    onClose: (id: string) => void;
    onAction: (communication: BannerCommunication) => void;
};

export const CommunicationBanner = ({ communication, onClose, onAction }: Props) => {
    const handleClose = () => {
        logEventString('CommunicationBanner.CloseButtonClick', 'true', {
            communication_id: communication.id,
            banner_theme: communication.details.banner.theme,
        });

        onClose(communication.id);
    };

    const handleButtonClick = () => {
        logEventString('CommunicationBanner.ActionButtonClick', 'true', {
            communication_id: communication.id,
            banner_theme: communication.details.banner.theme,
        });

        onAction(communication);
    };

    return (
        <div data-testid={communicationBannerTestIds.root}>
            <CommunicationBannerView communication={communication} onClose={handleClose} onClick={handleButtonClick} />
        </div>
    );
};
